import { useMemo } from 'react';
import { format } from 'date-fns';
import { arrayOf, bool, number, object, shape, string } from 'prop-types';
import { Button } from '@fff-web/fff-ui-shared';
import { onClickAddMore } from '../../../utils/subscriptions';
import OrderSummary from '../SharedComponents/OrderSummary/OrderSummary';
import Panel from '../SharedComponents/Panel/Panel';
import { getTotalQty } from '../SharedComponents/utils/helperFuncs';

const MIN_FREE_SHIPPING_AMOUNT = 49.99;

const NinetyDaysPanel = ({
  subscriptions,
  sysdata,
  displaySeparator = true,
  subTotal,
  editCampaign,
}) => {
  const nextShipmentNinetyDays = useMemo(() => {
    if (!subscriptions || subscriptions.length === 0) return 'Processing';
    const dates = subscriptions
      .map((sub) => sub.nextRenewalDate)
      .filter(Boolean)
      .sort();
    const closestDate = dates[0] || null;
    return closestDate ? format(closestDate, 'MMMM d') : 'Processing';
  }, [subscriptions]);
  const isFreeShipping = subTotal > MIN_FREE_SHIPPING_AMOUNT;
  const shippingFeeInCents = 0; // TODO: Get shipping fee from API
  const panelName = 'Shipping Every 3 Months';

  return (
    <div data-testid="ninety-days-container">
      <Panel
        currentSale={''} // TODO: Get current sale from API
        sysdata={sysdata}
        panelItems={subscriptions}
        panelName={panelName}
        nextShipmentDate={nextShipmentNinetyDays}
        sectionType="NINETY_DAYS"
        displayOrderSummary
        applyForFreeShipping
        displaySeparator={displaySeparator}
        isEditCampaignOpen={editCampaign?.userAccess}
        orderSummary={
          <OrderSummary
            title="Subscriptions"
            total={getTotalQty(subscriptions)}
            sum={subTotal}
            footnote="Total does not reflect credit applied."
            isRefillSection
            isFreeShipping={isFreeShipping}
            shippingFeeInCents={shippingFeeInCents}
          />
        }
        addMore={
          <Button onClick={() => onClickAddMore()} width="100%">
            ADD MORE
          </Button>
        }
      />
    </div>
  );
};

NinetyDaysPanel.propTypes = {
  subscriptions: arrayOf(object).isRequired,
  sysdata: shape({
    boxData: shape({
      customizeCampaignState: shape({}).isRequired,
      customizations: arrayOf(
        shape({
          additionalItems: arrayOf(
            shape({
              quantity: number.isRequired,
              price: number.isRequired,
            }),
          ).isRequired,
          questionType: string.isRequired,
          additionalItemCost: number.isRequired,
        }),
      ).isRequired,
    }),
    userData: shape({}).isRequired,
    isMobile: bool.isRequired,
  }).isRequired,
  displaySeparator: bool,
  subTotal: number.isRequired,
  editCampaign: shape({}).isRequired,
};

export default NinetyDaysPanel;
